import PDF_DEFAULT_0 from '~/assets/icons/DEFAULT_PDF_0.png';
import DEFAULT_PDF_LOGO from '~/assets/icons/DEFAULT_PDF_LOGO.png';

export const setBasicDefaultStyles = (selectedTemplate, dispatch, actions) => {
  if (!selectedTemplate) {
    dispatch(
      actions.setBasicInformation({
        field: 'coverImage',
        value: { img: PDF_DEFAULT_0 },
      }),
    );
  }

  if (selectedTemplate) {
    dispatch(
      actions.setBasicInformation({
        field: 'coverImage',
        value: { img: DEFAULT_PDF_LOGO },
      }),
    );
  }
};
